import { computed, unref } from "vue";

export function useEventUrlHelpers(event) {
  const unrefEvent = computed(() => unref(event));

  const homepageUrl = computed(() => {
    if (!unrefEvent.value.homepageUrl) return undefined;
    const homepage = unrefEvent.value.homepageUrl;
    if (homepage.includes("http:") || homepage.includes("https:")) {
      return homepage;
    }
    return "//" + homepage;
  });
  const broadcastUrl = computed(() => {
    if (!unrefEvent.value.broadcastUrl) return undefined;
    const broadcastUrl = unrefEvent.value.broadcastUrl;
    if (broadcastUrl.includes("http://") || broadcastUrl.includes("https://")) {
      return broadcastUrl;
    }
    return "//" + broadcastUrl;
  });
  const startingListUrl = computed(() => {
    if (!unrefEvent.value.startingListUrl) return undefined;
    const startingListUrl = unrefEvent.value.startingListUrl;
    if (
      startingListUrl.includes("http://") ||
      startingListUrl.includes("https://")
    ) {
      return startingListUrl;
    }
    return "//" + startingListUrl;
  });
  const externalRegistrationUrl = computed(() => {
    if (!unrefEvent.value.externalRegistrationUrl) return undefined;
    const externalRegistrationUrl = unrefEvent.value.externalRegistrationUrl;
    if (
      externalRegistrationUrl.includes("http://") ||
      externalRegistrationUrl.includes("https://") ||
      externalRegistrationUrl.includes("mailto:")
    ) {
      return externalRegistrationUrl;
    }
    return "//" + externalRegistrationUrl;
  });

  return {
    homepageUrl,
    broadcastUrl,
    startingListUrl,
    externalRegistrationUrl
  };
}
